const semanticClassNames = {
  root: 'hamburger-open-button',
  buttonLabel: 'hamburger-open-button__label',
  buttonIcon: 'hamburger-open-button__icon',
} as const;

export default semanticClassNames;
